// Use the worker in place of ultraFastBeeswarmX
type BeeswarmPosition = {
  x: number;
  y: number;
  r?: number;
  data?: any;
};

export function beeSwarmPosition(
  data: any,
  radius = 4,
  spacing = 0.1,
  jitterY = 2,
  maxLateralWidth = null,
): Promise<BeeswarmPosition[]> {
  return new Promise((resolve, reject) => {
    const worker = new Worker("/ultraFastBeeswarmWorker.js");

    worker.onmessage = function (event) {
      resolve(event.data);
      worker.terminate();
    };

    worker.onerror = function (error) {
      reject(error);
      worker.terminate();
    };

    worker.postMessage({
      data,
      radius,
      spacing,
      jitterY,
      maxLateralWidth,
      seed: 12345,
    });
  });
}
